import avatar from "../../Assets/avatar.svg";
import { FaLinkedin } from "react-icons/fa";

export const recommendations = [
    {
      id: 1,
      name: "Usama Nadeem Khan",
      position: "Principal Software Engineer",
      text: "I had the pleasure of working with Fahad. With extensive experience across multiple industries (Agri-Tech, Education, FinTech, IoT), he has a strong command of technologies like NodeJS, ExpressJS, and the MEAN stack. As a Backend Lead, he guided teams to deliver high-quality enterprise solutions, leveraging AWS services (EC2, S3) and both SQL (PostgreSQL, MySQL) and No-SQL (MongoDB) databases. He is also an excellent communicator, able to translate complex technical concepts to both technical teams and C-Level executives. I highly recommend Fahad for any technical or leadership role – his expertise and leadership would be an asset to any organization.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "February 24, 2025",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 2,
      name: "Muhammad Asad Asrar",
      position: "Principal Software Quality Assurance Engineer at Northbay Solutions",
      text: "It was a privilege to work with Al Fahad at NorthBay Solutions. He is a dynamic and results-driven professional with exceptional technical expertise and a keen eye for detail. Fahad's ability to navigate complex challenges and deliver innovative solutions is truly impressive. Beyond his technical skills, he is a dependable team player who fosters a positive and collaborative work environment. His strong work ethic and commitment to excellence make him an invaluable asset to any organization. I wholeheartedly recommend him for any opportunity that aligns with his remarkable talents.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "February 10, 2025",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 3,
      name: "Badar Arain",
      position: "Principal Software Engineer",
      text: "I had the pleasure of working with Al Fahad at NorthBay Solutions, and he is a highly skilled and dedicated professional. He is a great team player, always willing to help, and consistently delivers quality work. His problem-solving abilities and positive attitude make him a valuable asset to any team. I highly recommend him for any opportunity that matches his skills.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "February 3, 2025",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 4,
      name: "Kashaf",
      position: "Principal Software Engineer @ NorthBay Solutions",
      text: "I had the pleasure of working with Al Fahad, and I can confidently say he is one of the most hardworking and dedicated people I've met. He is always punctual, committed to his work, and gives his best effort in everything he does. He not only meets deadlines but also ensures the work is done with great quality. He is reliable, responsible, and a great team player who supports his colleagues whenever needed. Any team would be lucky to have him, and I highly recommend him to anyone looking for a dedicated professional.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "February 2, 2025",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 5,
      name: "Fahad Ameen",
      position: "Principal Software Engineer | Full-Stack Developer",
      text: "I'm excited to recommend a fantastic software engineer! I've had the pleasure of working with AlFahad, and their skills are truly impressive. They consistently deliver high-quality work and are a joy to collaborate with. If you're looking for a talented and dedicated software engineer, I highly recommend reaching out to AlFahad. They would be a valuable asset to any team.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "February 1, 2025",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 6,
      name: "Muhammad Bin Liaquat",
      position: "Full Stack Engineer at Technology Rivers",
      text: "I'm excited to recommend Al Fahad, who was an outstanding colleague at Technology Rivers. He's incredibly skilled and always pays close attention to the details, which really shows in the quality of his work. Fahad is known for his strong work ethic and willingness to go the extra mile to get things done right. He has a knack for solving complex problems and does it with a positive attitude that makes working with him a pleasure. Fahad is a true team player who supports and uplifts everyone around him. I'm confident he'll excel in any future role and achieve great things.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "August 21, 2024",
      relationship: "Was senior to Muhammad",
      image: avatar
    },
    {
      id: 7,
      name: "Nadeem Hunzai",
      position: "Quality Assurance Engineer",
      text: "I highly recommend Fahad as an exceptional developer. He approaches every project with confidence and a thorough understanding, never hesitating to ask the right questions until he fully grasps the requirements. Fahad not only delivers top-notch solutions but also has the remarkable ability to communicate complex ideas clearly and effectively. His dedication to excellence makes him an invaluable asset to any team.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "August 14, 2024",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 8,
      name: "Muhammad Aatif",
      position: "Sr. Software Quality Assurance Engineer",
      text: "I've had the pleasure of working with Al Fahad at Technology Rivers, where he excelled as a Software Engineer. Al Fahad is skilled in both front-end and back-end development. He is a quick learner, always up-to-date with the latest technologies, and a strong team player who communicates complex concepts clearly. Al Fahad's dedication and expertise make him an invaluable asset to any team. I highly recommend him for any role requiring a talented and reliable Software Engineer.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "August 5, 2024",
      relationship: "Worked together but on different teams",
      image: avatar
    },
    {
      id: 9,
      name: "Sabeeha Batool",
      position: "Software Quality Assurance Engineer",
      text: "I am pleased to write this recommendation for Al Fahad, who has been an exceptional backend developer and a valued colleague. During our time working together, he consistently demonstrated a high level of expertise in backend development, contributing significantly to our projects with both skill and dedication. Al Fahad is not only proficient in and dedicated to his work, but also exhibits a remarkable ability to solve complex technical problems efficiently. His work is characterized by attention to detail and a commitment to delivering high-quality solutions. Beyond his technical skills, Al Fahad is known for his positive and collaborative nature. He approach each task with enthusiasm and a can-do attitude, fostering a productive and pleasant work environment.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "August 1, 2024",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 10,
      name: "Anwaar ulhaq",
      position: "Software Engineer at Aircall",
      text: "I have worked with Al Fahad for almost a year now. His biggest strength is before delivering a task/feature he understands the whole scenario first then starts implementation. Before delivering the feature he also handles all of the corner cases which most of the developers usually miss. Pull requests are very clean with documentation and time complexity is taken care of all the time. All of the features delivered are already scalable. Very punctual and professional in work conduct.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "December 17, 2023",
      relationship: "Was senior to Al",
      image: avatar
    },
    {
      id: 11,
      name: "Muhammad Faizan",
      position: "Sr Flutter Dev",
      text: "Amazing developer and a passionate problem solver, always willing to go an extra mile",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "July 9, 2023",
      relationship: "Worked together on the same team",
      image: avatar
    },
    {
      id: 12,
      name: "Muhammad Amin Jan",
      position: "People | Processes | Operations",
      text: "AlFahad is a person with great skills and profound experience in problem solving, I hired him as MEAN Stack Developer and throughout his tenure at Ideofuzioin he proved his worth. His proactive approach towards providing a solution is priceless. He has exceptional RnD skills with ability learn rapidly. He is ready to deal with difficult situations and solve the problems on time. We worked on various projects at Ideofuzion and I was impressed by his intelligence, work ethics and commitment toward his job. I absolutely would recommend him as MEAN Stack Engineer.",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "November 19, 2019",
      relationship: "Managed Al directly",
      image: avatar
    },
    {
      id: 13,
      name: "Talha Malik",
      position: "Ex-Biconomy & Aarc",
      text: "Fahad was the part of my team. I really appreciate his working style. No doubt he is dedicated, focus and disciplined. He always took ownership of the work and stood whenever he is needed. He always takes critism in positive manner and deliver work on time. I am truly grateful for all the efforts you made for the team and company. wish you all the best for the carrer. keep soaring higher and higher <3",
      linkedin: "https://www.linkedin.com/in/al-fahad/details/recommendations/",
      date: "October 29, 2019",
      relationship: "Managed Al directly",
      image: avatar
    }
  ];
  